import { render, staticRenderFns } from "./AriaNewTabMessage.vue?vue&type=template&id=5dca3f2d&"
import script from "./AriaNewTabMessage.vue?vue&type=script&lang=js&"
export * from "./AriaNewTabMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dca3f2d')) {
      api.createRecord('5dca3f2d', component.options)
    } else {
      api.reload('5dca3f2d', component.options)
    }
    module.hot.accept("./AriaNewTabMessage.vue?vue&type=template&id=5dca3f2d&", function () {
      api.rerender('5dca3f2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/HelpfulHTMLElements/AriaNewTabMessage.vue"
export default component.exports